import Ultrastake from "./Ultrastake";

export default Ultrastake;
